import React from 'react';

class BrandDetail extends React.Component {

  render() {
    const brand = this.props.brand;

    if (!brand) {
      return <div className="text-secondary">正在加载品牌信息...</div>;
    }

    let brandImage;
    if (brand.images && brand.images.length) {
      brandImage = brand.images[0].full ? brand.images[0].full : brand.images[0].thumbnail;
    }
    return (
      <div>
        <h4>
          { `${brand.name}  ${brand.nameCN || ''}` }
          <span className="oi oi-pencil text-info ml-3 edit-pencil"
            onClick={ () => this.onClickEditPencil() }>
          </span>
        </h4>
        <div className='mt-3'>
          <img className='border-gray'
            src={ brandImage && brandImage.url }
            width={brandImage && brandImage.width * 0.7 }
            height={ brandImage && brandImage.height * 0.7 }
            alt="好像没有图片" />
        </div>
        <div className='mt-3'>
          <ul className=''>
            { brand.descriptions ? brand.descriptions.map((desc, idx) => {
              return (
                <li key={ idx } className='brand-intro'>
                  <div>{ desc }</div>
                </li>
              );
            }) : `还没有${brand.name}的介绍` }
          </ul>
        </div>
      </div>
    );
  }

  onClickEditPencil() {
    this.props.onClickEditPencil();
  }
}

export default BrandDetail;